module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"product":"Artikel","countQuantity":"Zählmenge","empty":"Leergutartikel","depositValue":"Pfandwert","baseUnit":"Grundeinheit"},"en":{"product":"Product","countQuantity":"Count quantity","empty":"Empty product","depositValue":"Deposit value","baseUnit":"Base unit"}}')
  delete Component.options._Ctor
}
